import { useEffect } from 'react';

import { isEqual } from 'lodash';

import { useCustomMemo } from 'common/helpers/useCustomMemo';

import type { PollingContextSubscriptionProps } from './PollingContextProvider';
import type { PollingContextSubscriptionPayload } from './withPollingContextSubscription';

export default function useSubscribeToPollingContext({
  startActions,
  stopActions,
  registerSubscription,
  unregisterSubscription,
}: PollingContextSubscriptionProps & PollingContextSubscriptionPayload) {
  const startMemoized = useCustomMemo(startActions, isEqual);
  const stopMemoized = useCustomMemo(stopActions, isEqual);

  useEffect(() => {
    const id = crypto.randomUUID();

    registerSubscription({
      id,
      startActions: startMemoized,
      stopActions: stopMemoized,
    });

    return () => unregisterSubscription(id);
  }, [startMemoized, stopMemoized, registerSubscription, unregisterSubscription]);
}
